import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { tabsGuard } from './core/auth/tabs.guard';
import { FaqPage } from './faq/faq.page';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'tabs/explore',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'legal',
    loadComponent: () => import('./legal/legal.page').then(m => m.LegalPage),
  },
  {
    path: 'privacy',
    loadComponent: () => import('./privacy/privacy.page').then(m => m.PrivacyPage),
  },
  {
    path: 'policy',
    loadComponent: () => import('./privacy/privacy.page').then(m => m.PrivacyPage),
  },
  {
    path: 'download',
    loadComponent: () => import('./download/download.page').then(m => m.DownloadPage),
  },
  {
    path: 'faq',
    loadComponent: () => Promise.resolve(FaqPage),
  },
  {
    path: 'share/review-story',
    loadComponent: () => import('./review-story-capture/review-story-capture.page').then(m => m.ReviewStoryCapturePage),
  },
  {
    path: 'profile/setup',
    loadComponent: () => import('./profile-setup/profile-setup.page').then(m => m.ProfileSetupPage),
    canActivate: [authGuard],
  },
  {
    path: 'u/:username',
    loadComponent: () => import('./pages/public-profile/public-profile.page').then(m => m.PublicProfilePage),
  },
  {
    path: 'p/:placeId',
    loadComponent: () => import('./place/place-detail.page').then(m => m.PlaceDetailPage),
  },
  {
    path: 'place/:placeId',
    loadComponent: () => import('./place/place-detail.page').then(m => m.PlaceDetailPage),
  },
  {
    path: 'notifications',
    redirectTo: 'tabs/notifications',
    pathMatch: 'full',
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
    canActivate: [tabsGuard],
  },
];
